<template>
  <v-dialog
    persistent
    transition=""
    :fullscreen="fullscreen"
    v-model="dialogConfirmSchedule"
    width="500"
    style="transition: all 3s;"
  >
    <!-- dialog de confirmação de marcar aula -->

    <v-card v-if="!professorId && !selectedProfessorId" style="">
      <v-card-text class="schedule-confirmation-dialog-text pt-5">
        <div
          v-for="professor in filteredProfessors"
          :key="professor.name"
          class="teachers-dialog-item"
          @click="selectedProfessorId = professor.user_id"
        >
          <div class="teacher-photo">
            <img
              width="100%"
              :src="professor.image ? professor.image : '/img/fav_icon2.png'"
              alt=""
              class="img-teacher-foto"
            />
          </div>
          <div class="teacher-name">
            {{ professor.name }}
            <v-rating v-if="professor.rating" size="18" background-color="rgba(68, 0, 153,0.2)" color="rgba(68, 0, 153,0.8)" dense :value="professor.rating" readonly empty-icon="mdi-star" full-icon="mdi-star" half-increments></v-rating>
            </div>
        </div>
      </v-card-text>

      <v-btn
        color="grey darken-1"
        rounded
        text
        @click="onClose"
        style="margin: 0 auto;"
      >
        Cancelar
      </v-btn>
    </v-card>
    <v-card v-else style="">
      <div v-if="!confirmedScheduleShow" id="conteudo-dialog-confirmar-aula">
        <v-card-title class="headline"></v-card-title>
        <v-card-text class="schedule-confirmation-dialog-text">
          <br /><br />
          AULA PARTICULAR<br />
          <span>{{ selectedSubject ? selectedSubject.name : 'Em casa' }}</span
          ><br />
          <span>{{
            date.toLocaleDateString("pt-BR", { weekday: "long" })
          }}</span
          ><br />
          <span>{{
            date.toLocaleDateString("pt-BR", { day: "numeric", month: "short" })
          }}</span
          ><br />
          <span>{{ hour }}h</span><br />
          COM PROF<br />
          <span>{{ professor.name }}</span
          ><br />
          <br /><br /><br />

          <v-textarea
            v-if="credits && credits > 0"
            v-model="description"
            solo
            no-resize
            flat
            outlined
            hint="<b>Obrigatório</b>. Ex.: MTM básica para o ENEM"
            persistent-hint
            name="input-7-4"
            label="O que você precisa aprender?"
            rows="2"
            mandatory
            class="pl-5 pr-5"
          ></v-textarea>
          <template v-else>
            <p>
              Você não possui créditos para marcar aula mas pode:
            </p>
            <v-btn to="/creditos" color="secondary" rounded depressed>
              Adquirir créditos
            </v-btn>
          </template>
        </v-card-text>

        <v-btn
          v-if="credits && credits > 0"
          color="secondary"
          rounded
          depressed
          x-large
          class=""
          style="width: 80%; margin: 15px 10%; color: #270057;"
          @click="confirmedSchedule"
          :loading="schedulingClass"
          :disabled="!description"
        >
          Marcar aula!
        </v-btn>

        <p 
          v-if="isHomeSchool"
          class="px-12 text-center" 
          style="opacity: 0.8; text-transform: capitalize;">
          {{ userProfile.street }}, {{ userProfile.neighborhood }}, {{ userProfile.number }}
        </p>

        <v-card-actions style="padding-top: 45px;">
          <!-- <div class="flex-grow-1"></div> -->

          <v-btn
            color="grey darken-1"
            text
            rounded
            @click="onClose"
            style="margin: 0 auto;"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </div>

      <div v-else id="schedule-confirmed">
        <v-card-text class="schedule-confirmation-dialog-text">
          <div
            class="schedule-confirmation-dialog-text"
            style="color: #440099; line-height: 1.3"
          >
            <br /><br /><br />

            <!-- ######################################## -->
            <!-- link do CODE PEN correto da animação -->
            <!-- https://codepen.io/simonwuyts/pen/mmMYzx -->
            <!-- ######################################## -->
            <svg
              id="successAnimation"
              class="animated"
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 70 70"
            >
              <path
                id="successAnimationResult"
                fill="#D8D8D8"
                d="M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z"
              />
              <circle
                id="successAnimationCircle"
                cx="35"
                cy="35"
                r="24"
                stroke="#979797"
                stroke-width="2"
                stroke-linecap="round"
                fill="transparent"
              />
              <polyline
                id="successAnimationCheck"
                stroke="#979797"
                stroke-width="2"
                points="23 34 34 43 47 27"
                fill="transparent"
              />
            </svg>
            <br /><br />
            <span style="font-size: 36px;"> AULA<br />MARCADA </span>
            <br /><br /><br />
            <span>
              {{ selectedSubject.name }} {{ isHomeSchool ? 'Em casa' : 'No cem' }}
              <br />
              {{
                new Date(date).toLocaleString("pt-BR", {
                  day: "numeric",
                  month: "short",
                })
              }} {{ date.toLocaleDateString("pt-BR", { weekday: "long", timezone: "UTC"}) }}
              <br />
              {{ hour }}h, {{ address }} </span
            ><br />

            prof<br />
            <span>{{ professor.name }}</span
            >
          </div>
        </v-card-text>

        <v-card-actions class="pt-0 pb-12">
          <v-btn
            color="grey darken-2"
            outlined
            rounded
            @click="onClose"
            style="margin: 0 auto 9px;"
          >
            Ok obrigado :)
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import StudentsRepository from "@/repositories/StudentsRepository";

export default {
  props: {
    hour: [String, Number],
    professorId: [Number, Boolean],
    date: [Date, String],
    professors: Array,
    classroom: Object,
    scheduleInformation: Object,
    freeTimes: Array,
    credits: [String, Number],
    visibility: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogConfirmSchedule: false,
      schedulingClass: false,
      selectedProfessorId: this.professorId,
      confirmedScheduleShow: false,
      description: undefined,
      fullscreen: undefined
    };
  },
  computed: {
    address() {
      return !this.isHomeSchool ? this.classroom.name : `${this.userProfile.street }, ${this.userProfile.neighborhood}, ${this.userProfile.number}`
    },
    ...mapState(["selectedSubject", "affiliates", 'userProfile', 'isHomeSchool']),
    filteredProfessors() {
      const availableProfessors = this.scheduleInformation.value.availableTimes.map(
        ({ user_id }) => user_id
      );
      return this.professors.filter(professor =>
        availableProfessors.includes(professor.user_id)
      );
    },
    professor() {
      return this.professorId
        ? this.filterProfessor(this.professorId)
        : this.filterProfessor(this.selectedProfessorId);
    },
    professorFreeTime() {
      return this.professorId
        ? this.filterFreeTime(this.professorId)
        : this.filterFreeTime(this.selectedProfessorId);
    }
  },
  watch: {
    visibility: {
      immediate: true,
      handler(visibility) {
        this.dialogConfirmSchedule = visibility;
      }
    }
  },
  methods: {
    filterProfessor(professorId) {
      return this.professors.filter(
        professor => professor.user_id === professorId
      )[0];
    },
    filterFreeTime(professorId) {
      return this.freeTimes.filter(
        freeTime => freeTime.user_id === professorId
      )[0];
    },
    hideagenda: function() {
      this.dialogConfirmSchedule = false;
    },
    async confirmedSchedule() {
      this.schedulingClass = true
      let scheduledClass = {
        subjectId: this.selectedSubject.id,
        freeTimeId: this.professorFreeTime.id,
        affiliateId: this.affiliates[0].id,
        date: this.date.toDateString(),
        classroomId: this.classroom ? this.classroom.id : null,
        professorId: this.professor.user_id,
        description: this.description
      };

      let response = await StudentsRepository.scheduleClass(scheduledClass, this.isHomeSchool);
      this.schedulingClass = false

      this.confirmedScheduleShow = true;
      // this.fullscreen = true;
    },
    onClose() {
      (this.dialogConfirmSchedule = false),
        (this.selectedProfessorId = undefined),
        (this.confirmedScheduleShow = false),
        (this.description = undefined);

      this.selectedProfessorId = undefined;
      this.$store.dispatch("loadStore");
      this.$emit("positive");
    }
  }
};
</script>
<style>
.v-card.v-sheet.theme--light {
  background: rgba(255, 255, 255, 1);
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(250, 250, 250, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, rgba(255, 255, 255, 1)),
    color-stop(100%, rgba(250, 250, 250, 1))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(250, 250, 250, 1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(250, 250, 250, 1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(250, 250, 250, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(250, 250, 250, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#fafafa', GradientType=0 );
}







.teacher-photo {
  display: flex;
  background-image: url("/assets_aluno/galileo_3.jpg");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 999px;
  height: 64px;
  width: 64px;
  border: 1px solid #eeeeee;
}
.img-teacher-foto{
  object-fit: cover;
  border-radius: 999px;
  border: 2px solid rgba(255,255,255,1);
  box-shadow: 0px 2px 6px rgba(29, 10, 53, 0.4);
}
.teacher-name {
  display: table-cell;
  vertical-align: middle;
  font-size: 18px;
  font-weight: 700;
  padding-left: 16px;
  color: #440099;
  width: 100%;
  text-align: left;
}





.schedule-confirmation-dialog-text {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: rgba(45, 35, 58, 0.5);
  line-height: 1.4;
}
.schedule-confirmation-dialog-text span {
  font-size: 21px;
  font-weight: 900;
  color: #440099;
  text-transform: uppercase;
}
#schedule-confirmed {
  background: rgba(68, 255, 153, 0.96);
  background: -moz-linear-gradient(
    top,
    rgba(89, 255, 165, 0.90) 0%,
    rgba(68, 255, 153, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, rgba(89, 255, 165, 0.90)),
    color-stop(100%, rgba(68, 255, 153, 1))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(89, 255, 165, 0.90) 0%,
    rgba(68, 255, 153, 1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(89, 255, 165, 0.90) 0%,
    rgba(68, 255, 153, 1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(89, 255, 165, 0.90) 0%,
    rgba(68, 255, 153, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(89, 255, 165, 0.90) 0%,
    rgba(68, 255, 153, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#44ff98', endColorstr='#40ed8e', GradientType=0 );
  height: 100%;
}

@keyframes scaleAnimation {
  0% {
    opacity: 0;
    transform: scale(3);
  }
  100% {
    opacity: 1;
    transform: scale(2);
  }
}

@keyframes drawCircle {
  0% {
    stroke-dashoffset: 151px;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes drawCheck {
  0% {
    stroke-dashoffset: 60px;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

#successAnimationCircle {
  stroke-dasharray: 151px 151px;
  stroke: #440099;
}

#successAnimationCheck {
  stroke-dasharray: 60px 60px;
  stroke: #440099;
}

#successAnimationResult {
  fill: #440099;
  opacity: 0;
}

#successAnimation.animated {
  animation: 2s ease-out 0s 1 both scaleAnimation;
}

#successAnimationCircle {
  animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCircle,
    0.3s linear 0.9s 1 both fadeOut;
}

#successAnimationCheck {
  animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCheck,
    0.3s linear 0.9s 1 both fadeOut;
}

#successAnimationResult {
  animation: 0.3s linear 0.9s both fadeIn;
}

#replay {
  background: rgba(255, 255, 255, 0.2);
  border: 0;
  border-radius: 3px;
  bottom: 100px;
  color: #fff;
  left: 50%;
  outline: 0;
  padding: 10px 30px;
  position: absolute;
  transform: translateX(-50%);
}
#replay:active {
  background: rgba(255, 255, 255, 0.1);
}
</style>
